module.exports = __webpack_public_path__ + "img/no_image_available.58f7230b.svg";